import React, { Component } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { Row, Col, Modal, Button } from "react-bootstrap";
import moment from "moment";

const DayOffDetailsModal = (props) => {
	let messages = [];

	const filterResponse = (selectedDayOff, key) => {
		if (selectedDayOff && selectedDayOff.responses) {
			const responseArray = selectedDayOff.responses;
			if (responseArray && Array.isArray(responseArray)) {
				return responseArray.filter((item) => item.response_id == key); // eslint-disable-line
			}
		}
		return [];
	};

	if (props.selectedDayOff && props.selectedDayOff.responses !== null) {
		messages = props.selectedDayOff.responses.filter((item) => {
			if ((item.response_id == 2 || item.response_id == 3) && item.message != null) { // eslint-disable-line
				return { user: item.full_name, message: item.message, id: item.id };
			}
			return null;
		});
	}

	const pending = filterResponse(props.selectedDayOff, 1, "response_id");
	const approved = filterResponse(props.selectedDayOff, 2, "response_id");
	const declined = filterResponse(props.selectedDayOff, 3, "response_id");

	return (
		<Modal className="dayoff-details-modal" show={props.showDetailsModal} onHide={props.handleClose}>
			<Modal.Header>
				<button type="button" className="close btn-close-modal" aria-hidden="true" onClick={props.handleClose}>&times;</button>
				<Modal.Title>{props.selectedDayOff.name}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Row>
					<Col md={3} sm={3} xs={3}><h4>Title:</h4></Col>
					<Col md={9} sm={9} xs={12}><h5>{props.selectedDayOff.name}</h5></Col>
				</Row>
				{props.selectedDayOff.description &&
					<Row>
						<Col md={3} sm={3} xs={3}><h4>Description:</h4></Col>
						<Col md={9} sm={9} xs={12}>
							<h5>{props.selectedDayOff.description}</h5>
						</Col>
					</Row>
				}
				{props.selectedDayOff.full_name &&
					<Row>
						<Col md={3} sm={3} xs={4}><h4>User:</h4> </Col>
						<Col md={9} sm={9} xs={8}><h5>{props.selectedDayOff.full_name}</h5> </Col>
					</Row>
				}
				<Row>
					<Col md={3} sm={3} xs={4}><h4>From:</h4> </Col>
					<Col md={9} sm={9} xs={8}> <h5>{moment(props.selectedDayOff.start).format("DD-MM-YYYY")}</h5> </Col>
				</Row>
				<Row>
					<Col md={3} sm={3} xs={4}><h4>To:</h4> </Col>
					<Col md={9} sm={9} xs={8}><h5>{moment(props.selectedDayOff.end).format("DD-MM-YYYY")}</h5> </Col>
				</Row>
				{props.selectedDayOff.country_name &&
					<Row>
						<Col md={3} sm={3} xs={4}><h4>Country:</h4> </Col>
						<Col md={9} sm={9} xs={8}> <h5>{props.selectedDayOff.country_name}</h5> </Col>
					</Row>
				}
				{approved.length > 0 &&
					<Row>
						<Col md={3} sm={3} xs={4}><h4>Approved by:</h4> </Col>
						<Col md={9} sm={9} xs={8}> {approved.map((item) => <h5 key={item.id}>{item.full_name}</h5>)}</Col>
					</Row>
				}
				{declined.length > 0 &&
					<Row>
						<Col md={3} sm={3} xs={4}><h4>Declined by:</h4> </Col>
						<Col md={9} sm={9} xs={8}> {declined.map((item) => <h5 key={item.id}>{item.full_name}</h5>)}</Col>
					</Row>
				}
				{pending.length > 0 &&
					<Row>
						<Col md={3} sm={3} xs={4}><h4>Pending:</h4> </Col>
						<Col md={9} sm={9} xs={8}>{pending.map((item) => <h5 key={item.id}>{item.full_name}</h5>)}</Col>
					</Row>
				}
				{props.selectedDayOff.status &&
					<Row>
						<Col md={3} sm={3} xs={4}><h4>Status:</h4> </Col>
						<Col md={9} sm={9} xs={8}> <h5><span className={`dayoff-status dayoff-status-${props.selectedDayOff.status}`}>{props.selectedDayOff.status}</span></h5> </Col>
					</Row>
				}
				{messages.length > 0 &&
					<Row>
						<Col md={3} sm={3} xs={12}><h4>Message:</h4></Col>
						<Col md={9} sm={9} xs={12}>
							{messages.map((item) => <h5 key={item.id}><b>{item.full_name}: </b> <span>{item.message}</span></h5>)}
						</Col>
					</Row>
				}

			</Modal.Body>
			<Modal.Footer>
				{props.isSuperAdmin &&
					<React.Fragment>
						<button title="Delete" onClick={() => props.dayOffToDelete(props.selectedDayOff)} className="btn btn-min btn-danger"> Delete </button>
						<Link to={`/days-off/${props.selectedDayOff.id}/${props.selectedDayOff.type_id}/edit`} className="btn btn-min btn-primary"> Edit </Link>
					</React.Fragment>
				}
				<Button bsStyle="default" className="btn-min" onClick={props.handleClose}>Close</Button>
			</Modal.Footer>
		</Modal>
	);
};

DayOffDetailsModal.defaultProps = {
	isSuperAdmin: false,
	dayOffToDelete: null,
	selectedDayOff: {
		id: null,
		name: "",
		start: "",
		end: "",
		type_name: "",
		type_id: null,
		responses: null,
	},
};

DayOffDetailsModal.propTypes = {
	isSuperAdmin: PropTypes.bool,
	showDetailsModal: PropTypes.bool.isRequired,
	handleClose: PropTypes.func.isRequired,
	dayOffToDelete: PropTypes.func,
	selectedDayOff: PropTypes.shape({
		id: PropTypes.number,
		name: PropTypes.string.isRequired,
		description: PropTypes.string,
		start: PropTypes.string.isRequired,
		end: PropTypes.string.isRequired,
		type_id: PropTypes.number,
		type_name: PropTypes.string.isRequired,
		country_name: PropTypes.string,
		full_name: PropTypes.string,
		// created_by: PropTypes.string,
		created_by_name: PropTypes.string,
		status: PropTypes.string,
		message: PropTypes.string,
		responses: PropTypes.arrayOf(
			PropTypes.object
		)
	}),
};

export default DayOffDetailsModal;



// WEBPACK FOOTER //
// ./src/components/modals/DayOffDetailsModal.js